<template>
  <b-button
    size="sm"
    class="float-right border mr-1 mt-1"
    :style="{ color: color, backgroundColor: bgColor }"
    @click="listBy()"
  >
    <i class="fa fa-list mr-2"></i>
    {{listTitle}}
  </b-button>
</template>


<script>
//import { EventBus } from "../../../../EventBus";
import { mapGetters } from "vuex";

export default {
  /* eslint-disable */
  props: [
    "listName", "listTitle",
  ],
  mounted() {
    
  },
  methods: {
    listBy() {
      console.log('listBy', this.activeTab, this.activeOption)
      this.$store.dispatch("layout/setActiveOption", this.listName)
      this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
      /* this.$store.dispatch("bookings/hasBookingsUnassigned")
      this.$store.dispatch("bookings/hasBookingsOrphanGroup")

      if ( this.activeTab == "Excursions") {
        this.$store
            .dispatch("buses/loadExcursionBuses")

        if ( this.activeOption == "Activity" ) {
          this.$store.commit('bookings/RESET_EXCURSION_DATA')
          this.$store.dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'})
        } else if ( this.activeOption == 'Excursion') {
          this.$store.commit('bookings/RESET_EXCURSION_DATA')
          this.$store.dispatch("bookings/loadBookingsByBusOrdered", {order_by: 'booking__order_1,customer_language'});
        } else if  ( this.activeOption == 'Path') {
          this.$store.commit('buses/RESET_BUSES_PATH')
          this.$store.dispatch("buses/busesPath")
        }
        this.$store.dispatch("bookings/pickupzoneSummary");
        
      } else if (this.activeTab == "Pickups") {
        this.$store.dispatch("buses/loadPickupBuses")
        

        if ( this.activeOption == 'Stop') {
          this.$store.commit('bookings/RESET_PICKUP_DATA')
          this.$store.dispatch("bookings/loadBookingsByStop")
        } else if ( this.activeOption == 'Pickup') {
          this.$store.commit('bookings/RESET_PICKUP_DATA')
          this.$store.dispatch("bookings/loadBookingsByBusOrdered", {order_by: 'booking__order,customer_language', bus_type: 'Pickup'})
        } else if ( this.activeOption == 'Excursion') {
          this.$store.commit('bookings/RESET_EXCURSION_DATA')
          this.$store.dispatch("bookings/loadBookingsByBusOrdered", {order_by: 'booking__order_1,customer_language', bus_type: 'Excursion'});
        } else if ( this.activeOption == 'Path') {
          this.$store.commit('buses/RESET_BUSES_PATH')
          this.$store.dispatch("buses/busesPath")
        }
        this.$store.dispatch("bookings/pickupzoneSummary");
      } else if ( this.activeTab == 'Unassigned') {
        this.$store.dispatch("bookings/loadBookingsUnassigned")
        this.$store.dispatch("bookings/loadOrphanBookings")
      } else if ( this.activeTab == 'Send') {
        this.$store
            .dispatch("buses/sentPlanningData") 
      }
      EventBus.optionChanged() */
      //this.$emit("listActive", this.activeOption);
    }
  },
  computed: {
    ...mapGetters(['activeOption']),
    ...mapGetters(['activeTab']),

    color() {
      return this.activeOption != this.listName ? "black" : "white";
    },
    bgColor() {
      return this.activeOption != this.listName ? "white" : "#2E3840";
    }
  },
  watch: {
    activeOption: function() {
      

    }
  }
};
</script>